import { useTranslation } from "react-i18next";

const InformationSecurityPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-5">
        <h2 className="font-bold text-4xl uppercase">
          {t("policy.personal_info.title")}
        </h2>
        <p>{t("policy.personal_info.intro")}</p>
        <p>{t("policy.personal_info.explanation")}</p>
      </div>
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.personal_info.purpose_scope.title")}
          </h2>
          <p>{t("policy.personal_info.purpose_scope.intro")}</p>
          <ul className="list-disc pl-5">
            <li>{t("policy.personal_info.purpose_scope.list1")}</li>
            <li>{t("policy.personal_info.purpose_scope.list2")}</li>
            <li>{t("policy.personal_info.purpose_scope.list3")}</li>
            <li>{t("policy.personal_info.purpose_scope.list4")}</li>
          </ul>
          <h2 className="font-bold text-xl">
            {t("policy.personal_info.collects_info.title")}
          </h2>
          <ul className="list-disc pl-5">
            <li>{t("policy.personal_info.collects_info.list1")}</li>
            <li>{t("policy.personal_info.collects_info.list2")}</li>
            <li>{t("policy.personal_info.collects_info.list3")}</li>
            <li>{t("policy.personal_info.collects_info.list4")}</li>
            <li>{t("policy.personal_info.collects_info.list5")}</li>
            <li>{t("policy.personal_info.collects_info.list6")}</li>
            <li>{t("policy.personal_info.collects_info.list7")}</li>
            <li>{t("policy.personal_info.collects_info.list8")}</li>
          </ul>
          <p>{t("policy.personal_info.accuracy_responsibility")}</p>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.personal_info.scope_of_use.title")}
          </h2>
          <p>{t("policy.personal_info.scope_of_use.intro")}</p>
          <ul className="list-disc pl-5">
            <li>{t("policy.personal_info.scope_of_use.list1")}</li>
            <li>{t("policy.personal_info.scope_of_use.list2")}</li>
            <li>{t("policy.personal_info.scope_of_use.list3")}</li>
            <li>{t("policy.personal_info.scope_of_use.list4")}</li>
            <li>
              TRAVERSIA takes the security of your personal data seriously.
              Please refer to our Privacy Policy for details on how we protect
              your information.
            </li>
          </ul>
          <p>{t("policy.personal_info.scope_of_use.shared_info")}</p>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.personal_info.storage_time.title")}
          </h2>
          <p>{t("policy.personal_info.storage_time.detail")}</p>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.personal_info.commitment.title")}
          </h2>
          <p>{t("policy.personal_info.commitment.intro")}</p>
          <ul className="list-disc pl-5">
            <li>{t("policy.personal_info.commitment.point1")}</li>
            <li>{t("policy.personal_info.commitment.point2")}</li>
            <li>{t("policy.personal_info.commitment.point3")}</li>
          </ul>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.personal_info.organizations.title")}
          </h2>
          <p>{t("policy.personal_info.organizations.detail")}</p>
          <ul className="list-disc pl-5">
            <li>{t("policy.personal_info.organizations.list1")}</li>
            <li>{t("policy.personal_info.organizations.list2")}</li>
          </ul>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.personal_info.contact_info.title")}
          </h2>
          <ul className="list-disc pl-5">
            <li>{t("policy.personal_info.contact_info.list1")}</li>
            <li>{t("policy.personal_info.contact_info.list2")}</li>
            <li>{t("policy.personal_info.contact_info.list3")}</li>
          </ul>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.personal_info.review_update.title")}
          </h2>
          <ul className="list-disc pl-5">
            <li>{t("policy.personal_info.review_update.detail1")}</li>
            <li>{t("policy.personal_info.review_update.detail2")}</li>
          </ul>
        </div>
        <div className="flex flex-col gap-5">
          <h2 className="font-bold text-xl">
            {t("policy.personal_info.complaint.title")}
          </h2>
          <ul className="list-disc pl-5">
            <li>{t("policy.personal_info.complaint.list1")}</li>
            <li>{t("policy.personal_info.complaint.list2")}</li>
            <li>{t("policy.personal_info.complaint.list3")}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InformationSecurityPolicy;
